export default __webpack_public_path__ + "ce012e600a4adac3a4d6fc12184129ec.png";